<template>
  <v-container class="py-8 px-4" max-width="720">
    <h2 class="text-h5 mb-6">{{ $t('views.architect.navigation.settings') }}</h2>

    <v-row dense>
      <v-col cols="12" md="6">
        <v-card class="pa-6 text-center" elevation="2" height="100%">
          <v-icon size="48" class="mb-4" color="primary">mdi-account-circle-outline</v-icon>
          <v-card-title class="text-h6 justify-center mb-2">
            {{ $t('views.architect.navigation.manageProfile') }}
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ $t('views.architect.comingSoon.message') }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="pa-6 text-center" elevation="2" height="100%">
          <v-icon size="48" class="mb-4" color="primary">mdi-account-group-outline</v-icon>
          <v-card-title class="text-h6 justify-center mb-2">
            {{ $t('views.architect.navigation.manageMembers') }}
          </v-card-title>
          <v-card-text class="text-body-2">
            {{ $t('views.architect.comingSoon.message') }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="d-flex justify-center mt-8">
      <v-btn prepend-icon="mdi-arrow-left" @click="goToDashboard">
        {{ $t('buttons.backToDashboard') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

function goToDashboard() {
  router.push({ name: 'ArchitectDashboard' });
}
</script>
